<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-toolbar-title>Holiday Information</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        scrollable
        max-width="700px"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container fluid>
              <v-layout wrap>

                <v-flex
                  xs6
                  sm6
                >
                  <!-- <v-text-field multiple label="Type" prepend-icon="person_pin" v-model="editedItem.type"></v-text-field> -->
                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    chips                    
                    flat
                    placeholder="Select only suggested Holiday Type"
                    :items="holidaytypes"
                    v-model="editedItem.holidayTypeID"
                    prepend-icon="assistant"
                    label="Type"
                    color="blue"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                </v-flex>

                <v-flex
                  xs6
                  sm6
                >
                  <!-- <v-text-field
                    multiple
                    label="Holiday Name"
                    prepend-icon="person_pin"
                    v-model="editedItem.holidayName"
                  ></v-text-field> -->

                  <v-autocomplete                   
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    chips                   
                    flat
                    placeholder="Select only suggested Holiday Name"
                    :items="holidayItems"
                    v-model="editedItem.holidayID"
                    prepend-icon="assistant"
                    label="Holiday Name"
                    item-text="name"
                    item-value="holidayID"
                    @change="holidaySelect"
                  ></v-autocomplete>

                </v-flex>

                <v-flex
                  xs6
                  sm6
                >
                  <p>
                    <v-icon>graphic_eq</v-icon>&nbsp;&nbsp;Compulsory?
                  </p>
                  <v-radio-group
                    v-model="editedItem.isCompulsory"
                    row
                  >
                    <v-radio
                      label="Yes"
                      value="true"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex
                  xs6
                  sm6
                >
                  <p>
                    <v-icon>graphic_eq</v-icon>&nbsp;&nbsp;Company Choose?
                  </p>
                  <v-radio-group
                    v-model="editedItem.isCompanyChoose"
                    row
                  >
                    <v-radio
                      label="Yes"
                      value="true"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex
                  xs4
                  sm4
                >
                  <v-text-field
                    type="date"
                    label="Date"
                    prepend-icon="insert_invitation"
                    v-model="editedItem.holidayDate"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                >
                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    chips                   
                    flat
                    placeholder="Select only suggested Allow Early Release"
                    :items="allowearlyrelease"
                    v-model="editedItem.allowEarlyReleaseID"
                    prepend-icon="filter_list"
                    label="Allow Early Release"
                    auto
                    chips
                    required
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>

                </v-flex>
                <v-flex
                  lg12
                  sm12
                >
                  <p>
                    <v-icon>insert_invitation</v-icon>&nbsp;&nbsp; Early Release Info
                  </p>
                </v-flex>
                <v-flex
                  lg6
                  sm12
                >

                  <v-datetime-picker
                    prepend-icon="insert_invitation"
                    label="Early Release Date & Time"
                    v-model="editedItem.earlyRelease"
                  >
                  </v-datetime-picker>
                </v-flex>

              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  outline
                  @click.native="close"
                >Cancel</v-btn>
                <v-btn
                  color="blue darken-1"
                  outline
                  @click.native="save"
                >Update</v-btn>
              </v-card-actions>
            </v-container>
          </v-card-text>

        </v-card>

      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >

        <!-- <td>{{ props.item.holidayTypeStr }}</td> -->
        <td>
          <v-badge
            class="success"
            v-if="props.item.holidayTypeID == 6"
          >Public Holiday</v-badge>
          <v-badge
            class="warning"
            v-else
          >Additional Holiday</v-badge>
        </td>
        <td>{{ props.item.holidayName }}</td>
        <td>
          <v-badge v-if="props.item.isCompulsory == 1">Yes</v-badge>
          <v-badge v-else>No</v-badge>
        </td>
        <td>
          <v-badge v-if="props.item.isCompanyChoose == 1">Yes</v-badge>
          <v-badge v-else>No</v-badge>
        </td>
        <!-- <td>{{ props.item.allowearlyreleaseStr }}</td> -->
        <td>
          <v-badge v-if="props.item.allowEarlyReleaseID == 11">Yes</v-badge>
          <v-badge v-else-if="props.item.allowEarlyReleaseID == 12">No</v-badge>
          <v-badge v-else>Possible</v-badge>
        </td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        No data available...
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { getHolidays } from '@/api/holiday';
import { getHolidayDetails } from '@/api/companyHoliday';
export default {
  data: () => ({
    loader: false,
    search: '',
    items: [
      { title: 'Clear Items' },
      { title: 'Edit details' },
      { title: 'Delete' }
    ],
    holidaytypes: [
      {
        id: 6,
        name: 'Public Holiday'
      },
      {
        id: 7,
        name: 'Additional Holiday'
      },
    ],

    allowearlyrelease: [

      {
        id: 11,
        name: 'Yes'
      },
      {
        id: 12,
        name: 'No'
      },
      {
        id: 13,
        name: 'Possible'
      }
    ],
    headers: [
      {
        text: 'Type',
        align: 'left',
        sortable: true,
        value: 'type'
      },
      {
        text: 'Holiday Name',
        align: 'left',
        sortable: true,
        value: 'holidayName'
      },

      {
        text: 'Compulsory',
        align: 'left',
        sortable: true,
        value: 'compulsory'
      },
      {
        text: 'Company Choose',
        align: 'left',
        sortable: true,
        value: 'CompanyChoose'
      },
      {
        text: 'Allow Early Release',
        align: 'left',
        sortable: true,
        value: 'AllowEarlyRelease'
      },

      { text: 'Action', value: 'action', align: 'middle' },
    ],

    gridItems: [],
    holidayItems: [],
    editedIndex: -1,
    companyHolidayId: null,
    editedItem: {
      valid: false,
      companyHolidayDetailId: -1,
      companyHolidayID: null,
      holidayID: null,
      holidayTypeID: null,
      allowEarlyReleaseID: null,
      allowEarlyReleaseStr: '',
      holidayName: '',
      holidayTypeStr: '',
      isCompulsory: "false",
      isCompanyChoose: "false",
      earlyRelease: null,
      holidayDate: null,
    },
    defaultItem: {
      valid: false,
      companyHolidayDetailId: -1,
      companyHolidayID: null,
      holidayID: null,
      holidayTypeID: null,
      allowEarlyReleaseID: null,
      allowEarlyReleaseStr: '',
      holidayName: '',
      holidayTypeStr: '',
      isCompulsory: "false",
      isCompanyChoose: "false",
      earlyRelease: null,
      holidayDate: null,
    },
    dialog: false,
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      console.log(this.companyHolidayId);
      if (this.companyHolidayId != -1) {
        getHolidayDetails(this.companyHolidayId)
          .then(response => {
            this.gridItems = response.data;
            console.log(this.gridItems);
          })
          .catch(error => {
           window.getApp.$emit('APP_API_ERROR', error);
          });
      }

      getHolidays('')
        .then(response => {
          this.holidayItems = response.data;
          console.log(this.holidayItems);
        })
        .catch(error => {
         window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      item.holidayDate = new Date(item.holidayDate).toISOString().substr(0, 10);
      item.earlyRelease = new Date(item.earlyRelease).toISOString().substr(0, 10);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.gridItems.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.gridItems.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.gridItems[this.editedIndex], this.editedItem);
      } else {
        this.gridItems.push(this.editedItem);
      }
      this.close();
    },
    companyCho (value) {
      console.log(value);
    },
    holidaySelect (value) {
      let uom = this.holidayItems.filter(o => o.holidayID == value);
      this.editedItem.holidayName = uom[0].name;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/calendar/HolidayGazettedInformation.vue